module.exports = __webpack_public_path__ + "img/stamp-landmaking.9544ae45.png";